import {
  SiteProject,
  CreateSiteProjectRequest,
  UpdateSiteProjectRequest,
} from '../models/SiteProject';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export class SiteProjectService {
  /**
   * 현장 프로젝트 목록 조회
   */
  static async listProjects(): Promise<SiteProject[]> {
    try {
      const response = await apiClient.get<ApiListResponse<SiteProject>>(API_ENDPOINTS.SITE_MANAGEMENT.LIST);
      return unwrapList(response, '현장 프로젝트 목록 조회 실패');
    } catch (error) {
      console.error('현장 프로젝트 목록 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 현장 프로젝트 상세 조회
   */
  static async getProject(id: number): Promise<SiteProject> {
    try {
      const response = await apiClient.get<ApiItemResponse<SiteProject>>(API_ENDPOINTS.SITE_MANAGEMENT.GET(id));
      return unwrapItem(response, '현장 프로젝트 조회 실패');
    } catch (error) {
      console.error('현장 프로젝트 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 현장 프로젝트 생성
   */
  static async createProject(data: CreateSiteProjectRequest): Promise<SiteProject> {
    try {
      const response = await apiClient.post<ApiItemResponse<SiteProject>>(
        API_ENDPOINTS.SITE_MANAGEMENT.CREATE,
        data
      );
      return unwrapItem(response, '현장 프로젝트 생성 실패');
    } catch (error) {
      console.error('현장 프로젝트 생성 실패:', error);
      throw error;
    }
  }

  /**
   * 현장 프로젝트 수정
   */
  static async updateProject(id: number, data: UpdateSiteProjectRequest): Promise<SiteProject> {
    try {
      const response = await apiClient.put<ApiItemResponse<SiteProject>>(
        API_ENDPOINTS.SITE_MANAGEMENT.UPDATE(id),
        data
      );
      return unwrapItem(response, '현장 프로젝트 수정 실패');
    } catch (error) {
      console.error('현장 프로젝트 수정 실패:', error);
      throw error;
    }
  }

  /**
   * 현장 프로젝트 삭제
   */
  static async deleteProject(id: number): Promise<void> {
    try {
      const response = await apiClient.delete<ApiOkResponse>(
        API_ENDPOINTS.SITE_MANAGEMENT.DELETE(id)
      );
      ensureOk(response, '현장 프로젝트 삭제 실패');
    } catch (error) {
      console.error('현장 프로젝트 삭제 실패:', error);
      throw error;
    }
  }
}
